import domReady from '@wordpress/dom-ready';

domReady(() => {
  const copyrightNotice = document.querySelector('footer .copyright-notice');
  copyrightNotice.textContent = `Derechos reservados ${new Date().getFullYear()}`
});
